import { useAuth } from "@/core/components/auth/store/auth";
import { Group } from "@/_old/features/filters/entities/group.types";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useCompanyGroups } from "../groups";
import { GroupsContextType } from "../../contexts/groups-context";

export const useGroupSelect = (): { data: GroupsContextType } => {
  const [isLoadingGroups, setIsLoadingGroups] = useState(true);
  const {
    userInfo: { user },
  } = useAuth();

  const groupId = useMemo(() => {
    return user.accessGroups?.length === 1 ? user.group_id : undefined;
  }, [user.accessGroups, user.group_id]);

  const [groupsList, setGroups] = useState<Group[]>([]);

  useEffect(() => {
    const fetchGroups = async () => {
      setIsLoadingGroups(true);
      const { data } = await useCompanyGroups({
        companyId: user.leagues_id[0],
        groupId,
      });
      setGroups(data);
      setIsLoadingGroups(false);
    };

    fetchGroups();
  }, [user.leagues_id, groupId]);

  const selectedGroupValue = useCallback(
    (groupId: number) => groupsList.find(({ id }) => id === groupId)?.name,
    [groupsList],
  );

  const selectedGroupValueWithName = useCallback(
    (groupId: number) => groupsList.find(({ id }) => id === groupId),
    [groupsList],
  );

  return {
    data: {
      groups: groupsList,
      selectedGroupValue,
      selectedGroupValueWithName,
      isLoadingGroups,
    },
  };
};
